module.exports = __webpack_public_path__ + "img/icon-street.c05ccde3.svg";